import {
  PassGroup,
  PassLog,
  Vehicle,
  Visitor,
  Person,
  Institution,
  Group,
  GroupType
} from "../../object";
import path from "path";

const actions = {
  async getGroups({ dispatch }, { pagination, filter, search, sortStack }) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/passApi/group/info/all/runtime",
        pagination,
        filter: filter,
        search,
        sortStack
      },
      { root: true }
    );
    return { items: items.map(item => PassGroup.fromAPI(item)), amount };
  },
  async setStandalone({ dispatch }, { vehicle, value }) {
    return dispatch(
      "getDataFromApi",
      {
        method: "post",
        url: `/passApi/object/standalone/${value ? "true" : "false"}`,
        data: {
          ids: [vehicle.plate]
        }
      },
      { root: true }
    );
  },
  async searchVehicles({ dispatch }, { plate }) {
    let res = await dispatch(
      "getDataFromApi",
      {
        method: "post",
        url: `/passApi/object/info/${plate}/origin`
      },
      { root: true }
    );
    // 预约车辆
    if (res.orders && res.orders.length) {
      let info = res.orders[0];
      let freezeStatus = res.isFreeze;
      let freezeTime = "";
      if (freezeStatus === "true") {
        freezeTime = res.freezeTime;
      }
      let v = new Vehicle({
        freezeStatus: freezeStatus,
        freezeTime: freezeTime,
        plate: info.order.visitorObjectCode,
        owner: Visitor.fromAPI(info.visitor),
        vehicleType: Vehicle.RESERVATION
      });
      return { items: [v], amount: 1 };
    }
    // 登记车辆
    if (res.vehicle) {
      let user = {};
      try {
        user = Person.fromAPI(res.user.userInfo);
        user.institution = Institution.fromAPI(res.user.selfConfig.currentInst);
        let org = Group.fromAPI(res.user.selfConfig.currentOrg);
        org.typeList.push(new GroupType({ name: "org" }));
        user.groupList = [org];
        user.orgName =
          (res.user &&
            res.user.selfConfig &&
            res.user.selfConfig.currentOrg &&
            res.user.selfConfig.currentOrg.name) ||
          user.orgName;
      } catch (e) {
        console.error(e);
      }

      let v = new Vehicle({
        plate: res.vehicle.plateNumber,
        vehicleType: res.vehicle.checkType,
        owner: user
      });
      console.log(47, res.user.selfConfig.currentOrg);
      return { items: [v], amount: 1 };
    }
    return { items: [], amount: 0 };
  },
  async getLogs(
    { dispatch, rootState },
    { pagination, filter, sortStack, search }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/passApi/pass/log/list",
        pagination,
        filter,
        sortStack,
        search,
        transDict: {
          plate: "objectId",
          passDatetime: "passTimeController",
          details: "remark"
        }
      },
      { root: true }
    );

    return {
      items: items.map(item =>
        PassLog.fromAPI(item, rootState.parkingLot.controllerList)
      ),
      amount
    };
  },
  getVehiclePassSummary({dispatch}, request) {
    return dispatch('getDataFromApi', {
      method: 'post',
      url: '/passApi/pass/log/statistics/summary',
      data: request
    }, {root: true});
  },
  getVehiclePassVehicles({dispatch}, {request, pagination}) {
    return dispatch('getDataFromApi', {
      method: 'post',
      url: '/passApi/pass/log/statistics/vehicles',
      data: request,
      params: {page: pagination.page - 1, size: pagination.rowsPerPage}
    }, {root: true});
  },
  async getVehicles(
    { dispatch },
    { pagination, sortStack, filter, search, self = false }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        method: "get",
        url: path.join("/passApi/check/list", self ? "self" : ""),
        pagination,
        sortStack,
        filter,
        search
      },
      { root: true }
    );

    return {
      items: items.map(t => {
        t.plate = t.plateNumber;
        let v = new Vehicle(t);
        v.status = t.status;
        return v;
      }),
      amount
    };
  }
};

export default {
  namespaced: true,
  actions
};
